<template>
    <div>
        <div class="list" v-for="(item,i)  in items" :key="i">
            <h3>
                {{ (i+1) }}、{{ item.name }}
            </h3>
            <div>
                <p>
                    1.个人消费金额需≥{{ item.consumptionAmount }}<br>
                    2.个人购买订单数量≥{{ item.consumptionOrderNum }}<br>
                </p>
                <p  v-if="i!=0"> 3.分享出去被购买的金额≥{{ item.shareAmount }}<br>
                    4.分享出去订单数量≥{{ item.shareOrderNum }}<br>
                    5.直属下级数量≥{{ item.subordinatesNum }}<br></p>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "guize",
        data() {
            return {
                items: [],
                channelType:""
            }
        },
        computed: {},
        filters: {},
        created() {
            this.level();
            this.channelType = JSON.parse(sessionStorage.getItem("user")).channelType;
    if(this.channelType == 'app') UnionDrugHealthy.hiddenShareIcon()
        },
        methods: {
            level() {
                this.$api.level({}).then(res => {
                    this.items = res.data.body;
                });
            },
        }
    }
</script>

<style scoped>
    .list{
        background: #fff;
        margin-bottom: 20px;
        padding: 30px;
    }

    .list h3{
        font-size:32px;
        font-weight:400;
        color:rgba(51,51,51,1);
        line-height:44px;
        margin-bottom: 16px;
    }

    .list p{
        font-size:28px;
        font-weight:400;
        color:rgba(153,153,153,1);
    }
</style>
